export var TypeActionBalloonInfo;
(function (TypeActionBalloonInfo) {
    TypeActionBalloonInfo["Received"] = "BalloonInfo > Received";
    TypeActionBalloonInfo["Request"] = "BalloonInfo > Request";
    TypeActionBalloonInfo["Consume"] = "BalloonInfo > Consume";
    TypeActionBalloonInfo["BuyWithGold"] = "BalloonInfo > BuyWithGold";
})(TypeActionBalloonInfo || (TypeActionBalloonInfo = {}));
export var actionBalloonInfo = function (balloonInfo) { return ({
    balloonInfo: balloonInfo,
    type: TypeActionBalloonInfo.Received,
}); };
export var actionBalloonInfoRequest = function () { return ({
    type: TypeActionBalloonInfo.Request,
}); };
export var actionBalloonOfferConsume = function (balloonContentId) { return ({
    balloonContentId: balloonContentId,
    type: TypeActionBalloonInfo.Consume,
}); };
export var actionBalloonOfferByWithGold = function (balloonContentId) { return ({
    balloonContentId: balloonContentId,
    type: TypeActionBalloonInfo.BuyWithGold,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/balloon/actionBalloonInfo.ts
// module id = 262
// module chunks = 3